export default "__VITE_ASSET__o8cCwVA4__"